export interface WindowResetAlert {
  candidateId: string;
  slotId: string;
  candidateName: string;
  assessmentId?: string;
  reason?: string;
  requestedAt: string;
}

export interface WindowResetRequestedPayload {
  candidateId: string;
  slotId: string;
  candidateName: string;
  assessmentId?: string;
  reason?: string;
  requestedAt: string;
}

export interface WindowResetActionPayload {
  candidateId: string;
  slotId: string;
}

/**
 * Internal Map key for deduplicating alerts in React state.
 */
export const getWindowResetAlertKey = (candidateId: string, slotId: string) =>
  `${candidateId}-${slotId}`;

/**
 * localStorage key for a pending window-reset request.
 * Format: windowReset_{slotId}_{candidateId}
 * Using slotId first makes prefix-scanning per slot trivial.
 */
export const getWindowResetLocalStorageKey = (slotId: string, candidateId: string) =>
  `windowReset_${slotId}_${candidateId}`;
